require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ar-eg-institution-البنك-الدولي.json") })
        }
      }, "path---ar-eg-institution-البنك-الدولي");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ar-eg-institution-البنك-الدولي!./.cache/json/ar-eg-institution-البنك-الدولي.json
// module id = 436
// module chunks = 231608221292675